import { z } from 'zod';

export const TaskScalarFieldEnumSchema = z.enum(['taskId','cityId','caseId','dateTaskStart','dateTaskDue','details','taskAssignedToId','dateTaskDone','numHours','laborCost','taskStatus']);

export default TaskScalarFieldEnumSchema;
